const parentRouter = [
  {
    label: '系统维护',
    path: ''
  }
]
const routes = [
  {
    path: '/maintain/loginLog',
    name: 'loginLog',
    meta: {
      title: '登录日志',
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/maintain/views/loginLog.vue')
  },
  {
    path: '/maintain/logError',
    name: 'logError',
    meta: {
      title: '异常日志',
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/maintain/views/logError.vue')
  },
  {
    path: '/maintain/logOper',
    name: 'logOper',
    meta: {
      title: '操作日志',
      parentTitle: parentRouter
    },
    component: () => import('@main/modules/maintain/views/logOper.vue')
  }
]
export default routes
